import React from 'react';
import { Modal } from 'react-bootstrap';
import './BrowserSupport.scss';
interface BrowserModalProps {
    show: boolean;
    onHide: () => void;
}
const BrowserSupport: React.FC<BrowserModalProps> = ({ show, onHide }) => {
    const handleClose = () => {
        onHide(); // Call the onHide function passed from the parent component
    };
    return (
        <div className='BrowserSupport'>
            {/* Your page content */}
            <Modal class="browserModal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Modal heading
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    We're sorry, unfortunately we do not support private browsing in FireFox; please turn off private browsing to continue with your purchase.
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default BrowserSupport;
